import { render } from "./Marketplace.vue?vue&type=template&id=ef30234a&scoped=true&ts=true"
import script from "./Marketplace.vue?vue&type=script&lang=ts"
export * from "./Marketplace.vue?vue&type=script&lang=ts"

import "./Marketplace.vue?vue&type=style&index=0&id=ef30234a&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef30234a"]])

export default __exports__